import React, {useState, useEffect} from 'react';
import HeaderStep from '../../../components/HeaderStep/HeaderStep';
import stylesForm from '../Form/Form.module.scss';
import { Form, Select } from 'antd';
import FormSteps from '../Form/Form';
import { useSelector } from 'react-redux';


const Civile = (props) => {

    const { Option } = Select;
    
    const erroriSalvaStep = useSelector(state => state.dataReducer.salvaStep.dati);
    const [errorMessageStatoCivile, setErrorMessageStatoCivile] = useState(null);

    useEffect(() => {
        if(erroriSalvaStep){
            erroriSalvaStep.forEach(errore => {
                switch(errore.errorCode) {
                    case "statoCivile":
                        setErrorMessageStatoCivile(errore.errorMessage);
                    break;
                    default:
                        setErrorMessageStatoCivile(null);
                    break;
                }
            });
        }else{
            setErrorMessageStatoCivile(null);
        }
    }, [erroriSalvaStep]);

    /*function cambioCivile(value) {
        console.log(`Stato civile:  ${value}`);
    }*/
    
    return (
        <div className={stylesForm.Form}>

            <HeaderStep titolo='Stato civile' 
                        sottotitolo ='' />

            <FormSteps formId="step6" bloccoAvanzamento={false}>

            <label className={stylesForm.floatingLabel} htmlFor="civile">Stato civile*</label>
            <Form.Item name="statoCivile" help={errorMessageStatoCivile}
            rules={[
                {
                    required: true,
                    message: 'Scegli il tuo stato civile',
                }
            ]}
            >
                <Select
                        placeholder="Stato civile*"
                        name='civile'
                >
                    <Option value={null}>Seleziona stato civile*</Option>
                <Option value="C">Celibe/Nubile</Option>
                <Option value="D">Divorziato</Option>
                <Option value="S">Separato</Option>
                <Option value="V">Vedovo</Option>
                <Option value="M">Coniugato</Option>
                <Option value="E">Convivente</Option>
                </Select>
            </Form.Item>

            </FormSteps>
        </div>
    )
}

export default Civile;